import { useEffect } from "react";
import { APIRoutes } from "../utils/constants";
import { getCurrentAuth } from "./useAxiosPrivate";
import HttpService from "./Https-services";
import {
  deriveSubscriptionProperties,
  setGaUserProperties,
} from "../utils/gaUser";

/**
 * HTPTV-683 — on an authenticated load, fetch the user's subscription details
 * and set the GA4 user properties (subscription_status / plan_tier /
 * billing_period). user_properties persist for the GA session, so a single set
 * on load is enough. Single-game-only buyers have no subscription, so they
 * correctly resolve to subscription_status = "none".
 */
const useGaSubscriptionProperties = (): void => {
  useEffect(() => {
    const auth = getCurrentAuth();
    if (!auth?.AccessToken) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await HttpService.get(APIRoutes.GetSubscriptionDetials);
        if (!cancelled) {
          setGaUserProperties(deriveSubscriptionProperties(res?.data?.data));
        }
      } catch {
        // No subscription / fetch error -> report "none" so segments aren't skewed.
        if (!cancelled) setGaUserProperties({ subscription_status: "none" });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
};

export default useGaSubscriptionProperties;
